<template>
  <div class="c-bg--gray--pc c-common-footer-fixed">
    <div class="c-common-footer-fixed__inner">
      <TheHeader ref="theHeader" />
      <div class="c-common-inner">
        <TheTemplateI heading="付与基準一覧" :indicated-item="[]">
          <template #contents>
            <div class="p-the-page-i02">
              <div class="p-the-page-i02__inner">
                <div class="p-the-page-i02__image">
                  <IconBase
                    :width="iconSize"
                    :height="iconSize"
                    view-box="0 0 70 70"
                    icon-color="#c4c4c4"
                  >
                    <IconTrophy />
                  </IconBase>
                </div>
                <div class="p-the-page-i02__body">
                  <div class="p-the-page-i02__body__text">
                    <p>
                      付与基準の登録がありません。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </TheTemplateI>
      </div>
    </div>
    <TheFooter />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import TheHeader from "@/common/components/organisms/TheHeader.vue";
import TheFooter from "@/common/components/organisms/TheFooter.vue";

import IconBase from "@/common/components/atoms/IconBase.vue";
import IconTrophy from "@/common/components/icons/IconTrophy.vue";
import TheTemplateI from "@/general/components/templates/TheTemplateI.vue";
import globals from "@/general/store/modules/globals";
import commons from "@/common/store/modules/commons";
import CONST_DATA from "@/general/mixins/const/constData";
import AuthStorage from "@/general/utils/auth";

@Options({
  components: {
    TheHeader,
    TheFooter,
    IconBase,
    IconTrophy,
    TheTemplateI
  }
})
export default class GrantCriteriaListNone extends Vue {
  isSp: any = globals.isSpScreenWidth;
  breadcrumb: any = [];

  declare $refs: {
    theHeader: TheHeader;
  };

  get iconSize() {
    const resultSize: any = {
      true: 48,
      false: 80
    };

    return resultSize[this.isSp];
  }

  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const id = parseInt(urlParams.get("id") as string);
    const searchParam = urlParams.get("search") ? urlParams.get("search") : "";
    const orderingParam = urlParams.get("ordering")
      ? (urlParams.get("ordering") as string)
      : "";
    const pageParm = urlParams.get("page")
      ? parseInt(urlParams.get("page") as string)
      : 1;
    this.breadcrumb = [
      {
        text: "",
        url: CONST_DATA.SITE_MAP.TOP_PAGE,
        pageType: "home"
      },
      {
        text: "付与基準一覧",
        url:
          `${CONST_DATA.SITE_MAP.GRANT_CRITERIA}?ordering=` +
          orderingParam +
          "&search=" +
          searchParam +
          "&page=" +
          pageParm,
        pageType: "lower"
      },
      {
        text: "付与基準一覧",
        url: CONST_DATA.SITE_MAP.DEFAULT,
        pageType: "lower"
      }
    ];
    await commons.getBreadcrumb(this.breadcrumb);
  }
}
</script>

<style lang="scss" scoped>
.p-the-page-i02 {
  @include pc {
    padding: 0 0 rem(16);
  }
  @include sp {
    padding: rem(48) 0 rem(64);
  }

  &__inner {
  }

  &__image {
    text-align: center;
  }

  &__body {
    margin-top: rem(16);

    &__text {
      font-size: $text-size__body--l;
      text-align: center;
      font-weight: bold;

      p + p {
        @include pc {
          margin-top: rem(8);
        }
        @include sp {
          margin-top: rem(16);
        }
      }
    }
  }
}
</style>
